var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinervaWavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "minerva_wav_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 78.951,
    height: 90.026,
    viewBox: "0 0 78.951 90.026",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139306",
    "data-name": "\\uD328\\uC2A4 139306",
    d: "M64.912,85.795H1.821A1.821,1.821,0,0,1,0,83.974V1.821A1.821,1.821,0,0,1,1.821,0H64.912a1.821,1.821,0,0,1,1.821,1.821V83.974A1.821,1.821,0,0,1,64.912,85.795Z",
    transform: "translate(12.218 4.231)",
    fill: "#939598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139307",
    "data-name": "\\uD328\\uC2A4 139307",
    d: "M43.376,0H1.821A1.821,1.821,0,0,0,0,1.821V83.974A1.821,1.821,0,0,0,1.821,85.8H64.912a1.821,1.821,0,0,0,1.821-1.821V22.6Z",
    transform: "translate(7.987 0)",
    fill: "#f1f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139308",
    "data-name": "\\uD328\\uC2A4 139308",
    d: "M.91,75.808A.913.913,0,0,1,0,74.9V.91A.917.917,0,0,1,.91,0H27.077a.91.91,0,1,1,0,1.821H1.821V74.9A.91.91,0,0,1,.91,75.808ZM30.719,1.821a.91.91,0,1,1,.91-.91A.91.91,0,0,1,30.719,1.821Z",
    transform: "translate(9.807 1.82)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139309",
    "data-name": "\\uD328\\uC2A4 139309",
    d: "M62.181,0V61.225a1.821,1.821,0,0,1-1.821,1.821H0v2.731A1.821,1.821,0,0,0,1.821,67.6H64.912a1.821,1.821,0,0,0,1.821-1.821V4.405Z",
    transform: "translate(7.987 18.197)",
    fill: "#e6e7e8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139310",
    "data-name": "\\uD328\\uC2A4 139310",
    d: "M64.457,0V61.3a1.821,1.821,0,0,1-1.821,1.821H0v.455A1.821,1.821,0,0,0,1.821,65.4H64.912a1.821,1.821,0,0,0,1.821-1.821V2.2Z",
    transform: "translate(7.987 20.4)",
    fill: "#d1d3d4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139311",
    "data-name": "\\uD328\\uC2A4 139311",
    d: "M0,20.9A1.707,1.707,0,0,0,1.707,22.6H23.358L0,0Z",
    transform: "translate(51.362)",
    fill: "#d1d3d4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139312",
    "data-name": "\\uD328\\uC2A4 139312",
    d: "M43,16.255H1.821A1.821,1.821,0,0,1,0,14.434V1.821A1.821,1.821,0,0,1,1.821,0H43a1.821,1.821,0,0,1,1.821,1.821V14.434A1.821,1.821,0,0,1,43,16.255Z",
    transform: "translate(0 6.347)",
    fill: "#a54af4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139313",
    "data-name": "\\uD328\\uC2A4 139313",
    d: "M5.88,1.779v6.7a4.416,4.416,0,1,0,.072,8.308,4.352,4.352,0,0,0,2.87-4.151h0V4.3a.711.711,0,0,1,.711-.71.723.723,0,0,1,.214.033l2.693.854a1.467,1.467,0,0,0,1.841-.955l.005-.018h0a1.466,1.466,0,0,0-.968-1.824L8.185.081A1.774,1.774,0,0,0,5.962,1.247,1.747,1.747,0,0,0,5.88,1.779Z",
    transform: "translate(17.543 34.372)",
    fill: "#b171f4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139314",
    "data-name": "\\uD328\\uC2A4 139314",
    d: "M5.88,1.775v6.7a4.416,4.416,0,1,0,.072,8.308,4.349,4.349,0,0,0,2.87-4.151h0V4.3a.711.711,0,0,1,.925-.677l2.693.854a1.466,1.466,0,0,0,1.84-.955l.005-.017h0a1.466,1.466,0,0,0-.967-1.824L8.182.08A1.776,1.776,0,0,0,5.96,1.251,1.745,1.745,0,0,0,5.88,1.775Z",
    transform: "translate(52.168 57.839)",
    fill: "#b171f4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139315",
    "data-name": "\\uD328\\uC2A4 139315",
    d: "M30.96.05,10.506,6.008a1.23,1.23,0,0,0-.885,1.18V22.1a6.513,6.513,0,1,0,3.4,5.725V11.07a.612.612,0,0,1,.443-.589L28.341,6.147a.614.614,0,0,1,.787.59V16.865a6.513,6.513,0,1,0,3.4,5.725V1.229A1.227,1.227,0,0,0,30.96.05Z",
    transform: "translate(20.866 37.177)",
    fill: "#a54af4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_139370",
    "data-name": "\\uD328\\uC2A4 139370",
    d: "M14.36,0,11.431,10.384H9.323L7.166,2.674l-2.1,7.711H2.949L0,0H2.37L4.141,7.1,6.091,0H8.358l1.9,7.118L12.079,0ZM24.734,10.384h-2.4l-.786-2.253H17.457l-.786,2.253h-2.3L18.291,0h2.522ZM20.971,6.518,19.5,2.329,18.036,6.518ZM34.549,0,30.608,10.384H28.286L24.351,0h2.391l2.749,7.587L32.234,0Z",
    transform: "translate(5.355 9.677)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinervaWavIcon);
export default __webpack_public_path__ + "static/media/minerva_wav_icon.f0b527d3770778de2af6dd4484211d86.svg";
export { ForwardRef as ReactComponent };